module.exports = __webpack_public_path__ + "img/third-banner-model.baebe62b.png";